import React, { useContext } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import HomeLayout from '../Home/HomeLayout';
import Registration from '../Registration/Registration';
import Materials from '../Materials/Materials';
import AdminPanel from '../AdminPanel/AdminPanel';
import AdminLogin from '../AdminLogin/AdminLogin';
import { AuthContext } from '../../utils/AuthContext';

const AdminPanelRoute = () => {
  const { isAuthenticated, isLoading } = useContext(AuthContext);

  if (isLoading) {
    return (
      <div className="admin-loading">
        <div className="loading-spinner" />
        <p>Загрузка...</p>
      </div>
    );
  }

  return isAuthenticated ? <AdminPanel /> : <Navigate to="/admin" replace />;
};

const AdminLoginRoute = () => {
  const { isAuthenticated, isLoading } = useContext(AuthContext);

  if (isLoading) {
    return (
      <div className="admin-loading">
        <div className="loading-spinner" />
        <p>Загрузка...</p>
      </div>
    );
  }

  return isAuthenticated ? <Navigate to="/admin-panel" replace /> : <AdminLogin />;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<HomeLayout />}>
      <Route path="registration" element={<Registration />} />
    </Route>
    <Route path="/materials" element={<Materials />} />
    <Route path="/admin" element={<AdminLoginRoute />} />
    <Route path="/admin-panel" element={<AdminPanelRoute />} />
  </Routes>
);

export default AppRoutes;
